import { combineReducers } from "@reduxjs/toolkit";
import userReducer from "./features/user/userSlice";
import serviceReducer from "./features/service/serviceSlice";

const rootReducer = combineReducers({
  user: userReducer,
  service: serviceReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
